module.exports = __webpack_public_path__ + "static/media/dart.63a1fa89.svg";